import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

export type EhrConfigs = {
  dosage_quantity_units: string[];
  dosage_frequencies: string[];
};

type GetEhrConfigsResponse = {
  message: string;
  code: number;
  success: boolean;
  configs: EhrConfigs;
};

export const useGetEhrConfigs = (
  options?: Omit<UseQueryOptions<EhrConfigs>, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['ehrConfigs'],
    queryFn: () =>
      integrationsApi
        .get<GetEhrConfigsResponse>('/ehr/configs')
        .then((res) => res.data.configs),
    refetchOnWindowFocus: false,
    ...options,
  });
};
